// biome-ignore lint/performance/noNamespaceImport: imported shadcn component
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import type * as React from 'react';

import { cn } from '@/lib/utils';

const Avatar = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> & {
  className?: string;
} & {
  ref?: React.RefObject<React.ElementRef<typeof AvatarPrimitive.Root> | null>;
}) => (
  <AvatarPrimitive.Root
    className={cn(
      'relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full',
      className,
    )}
    ref={ref}
    {...props}
  />
);
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image> & {
  className?: string;
} & {
  ref?: React.RefObject<React.ElementRef<typeof AvatarPrimitive.Image> | null>;
}) => (
  <AvatarPrimitive.Image
    className={cn('aspect-square h-full w-full', className)}
    ref={ref}
    {...props}
  />
);
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = ({
  className,
  hslColor,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback> & {
  className?: string;
  hslColor?: string;
} & {
  ref?: React.RefObject<React.ElementRef<
    typeof AvatarPrimitive.Fallback
  > | null>;
}) => (
  <AvatarPrimitive.Fallback
    className={cn(
      'flex h-full w-full items-center justify-center rounded-full bg-primary-active text-primary-foreground',
      className,
    )}
    ref={ref}
    style={{ backgroundColor: hslColor }}
    {...props}
  />
);
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarFallback, AvatarImage };
